import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './view.scss';

export const PropertyView = ({
    isCollapsible,
    headline,
    children,
    collapse,
    isDetailsWrapper
}) => (
    <div
        className={
            classnames('property', {
                'property--collapsible': isCollapsible,
                'property--details-wrapper': isDetailsWrapper
            })
        }
    >
        {
            (isCollapsible)
                ? (
                    <button
                        className="property__headline"
                        type="button"
                        onClick={ (event) => {
                            collapse(event);
                        } }
                    >
                        { headline }
                    </button>
                )
                : (<h4 className="property__headline">{ headline }</h4>)
        }
        <div className="property__container">{ children }</div>
    </div>
);

PropertyView.defaultProps = {
    isDetailsWrapper: false
};

PropertyView.propTypes = {
    isCollapsible: PropTypes.bool.isRequired,
    headline: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    collapse: PropTypes.func.isRequired,
    isDetailsWrapper: PropTypes.bool
};